<template>
    <div class="commer-content box-sizing case">
        <div class="commer-list">
            <p class="commer-list-title">
				项目案例>案例列表
			</p>
            <div class="commer-list-seacch-box" style="margin-bottom: 40px;">
                <div class="left-search">
                    <el-input
                        placeholder="请输入关键字"
                        suffix-icon="el-icon-search"
                        v-model="getListParams.text" class="wordSearch" clearable>
                    </el-input>
                </div>
                <div class="right-add">
                    <el-button type="info" icon="el-icon-plus" @click='operation(1,"")'>新增</el-button>
                </div>
            </div>
            <!-- <div>
                
            </div> -->
            <!-- <div class="commer-list-export-box">
				<span>共查询到{{totals}}个结果</span>
				<div class="right-add">
				  <el-button type="info" icon="el-icon-plus" @click='operation(1,"")'>新增</el-button>
			   </div>
			</div> -->
            <div class="table-list">
				<el-table
					:data="tableData"
					border
					style="width: 100%">
					<el-table-column
						type="index"
						label="序号"
						width="70">
					</el-table-column>
                    <el-table-column
                        prop="title"
                        label="标题">
                    </el-table-column>
                    <el-table-column
                        prop="desc"
                        label="描述">
                    </el-table-column>
                    <!-- <el-table-column
                    prop="status"
                    label=" 图片"  width='100'>
                    <template slot-scope="scope">
                        <img :src="scope.row.imgUrl?scope.row.imgUrl:''">
                    </template>
                    </el-table-column> -->
                    <el-table-column
                        prop="createDate"
                        label="创建时间">
                        <template slot-scope="scope">
                            <span>{{$moment(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="releaseDate"
                        label="发布时间">
                        <template slot-scope="scope">
                            <span>{{$moment(scope.row.releaseDate).format('YYYY-MM-DD HH:mm:ss') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        width="220">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click='operation(2,scope.row.id)'>编辑</el-button>
                            <el-button type="text" size="small"  @click='ifDelete(scope.row.id)'>删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pages">
				<el-pagination
					@current-change="getList"
					:current-page="getListParams.pageNo"
					:page-size="getListParams.pageSize"
					layout="total, prev, pager, next, jumper"
					:total="totals">
				 </el-pagination>
		   </div>
        </div>
        <el-dialog
		:title="titleMsg"
		:visible.sync="ifAdd"
		:modal-append-to-body='false'
		width='50%'>
            <el-main>
                <el-form :model="addParams" ref="addParams" label-width="100px" class="demo-ruleForm" :rules="rules">
                    <div style="display:flex;margin-bottom:10px;">
                        <span class="LOGO">图片</span>
                        <photo-upload :imgList='addParams.imgUrl' @uploadImg='uploadImg'></photo-upload>
                    </div>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="标题" prop="title">
                                <el-input v-model="addParams.title" placeholder="请输入标题"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="类型" prop="type">
                                <el-select v-model="addParams.type" placeholder="请选择类型">
                                    <el-option
                                        v-for="item in typeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="描述" prop="desc">
                                <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入描述"
                                    v-model="addParams.desc">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- <el-row>
                        <el-col :span="12">
                            <el-form-item label="内容" prop="content">
                                <el-input
                                    type="textarea"
                                    :rows="4"
                                    placeholder="请输入内容"
                                    v-model="addParams.content">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="内容" prop="content">
                                <editor
                                    id="tinymce"
                                    v-model="addParams.content"
                                    :init="init">
                                </editor>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-main>
            <span slot="footer" class="dialog-footer">
				<el-button @click="ifAdd = false">取 消</el-button>
				<el-button type="primary" @click="save('addParams')"> 保 存</el-button>
			</span>
            
        </el-dialog>
    </div>
</template>
<script>
// 引入基本文件
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver'
// import 'tinymce/icons/default/icons.min.js'
import "tinymce/icons/default/icons.min.js";

// 引入你需要的插件
import 'tinymce/plugins/paste';
import 'tinymce/plugins/link';

import "tinymce/plugins/image";
import "tinymce/plugins/preview";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import 'tinymce/plugins/contextmenu' //右键菜单插件
import 'tinymce/plugins/wordcount' // 字数统计插件
import 'tinymce/plugins/colorpicker' //选择颜色插件
import 'tinymce/plugins/textcolor' //文本颜色插件
import 'tinymce/plugins/fullscreen' //全屏
import 'tinymce/plugins/imagetools' //全屏
import 'tinymce/plugins/code' //全屏


import PhotoUpload from  '@/components/public/photoUpload.vue' 
export default {
    data(){
        return{
            titleMsg:'新增',
            ifAdd:false,
            totals:0,
            tableData:[],
            getListParams:{
                pageNo:1,
                pageSize:10,
                text:''
            },
            addParams:{
                title:'',
                imgUrl:'',
                type:'',
                content:'',
                desc:'',
            },
            rules:{

            },
            typeList:[{
                name:'商业',
                id:1
            },{
                name:'工厂',
                id:2
            },{
                name:'数据中心',
                id:3
            }],
            operationStatus:'',
            baseUrl:process.env.apiUrl,
            init:{
                paste_data_images: true,
                 language_url: "../../../static/tinymce/zh_CN.js",
                language: "zh_CN",
                skin_url: "../../../static/tinymce/skins/ui/oxide",
                height: 770,
                min_height: 770,
                max_height: 770,
                // toolbar_mode: "wrap",
                plugins: 'lists image preview link table colorpicker textcolor paste code',
        //         toolbar: 'undo redo | fontsizeselect fontselect | alignleft aligncenter alignright alignjustify | lists image preview link table',
               toolbar: 'undo redo |  formatselect fontselect fontsizeselect| bold italic forecolor backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists image media table | removeformat',
                content_style: "p {margin: 5px 0;}",
                fontsize_formats: "8px 10px 12px 14px 16px 18px 20px 22px 24px 26px 28px 30px 32px 34px 36px",
                font_formats:
                  "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;",
                branding: false,
                images_upload_handler: (blobInfo, success) => {
                    var formData = new FormData();
                    formData.set('file', blobInfo.blob());
                    console.log("======>",blobInfo.blob(),formData)
                    //这里为自己的上传接口调用方法
                    this.$http.post(process.env.apiUrl+'/api/upload',formData,{ifqs:false},{headers: {'Content-Type': 'multipart/form-data'}}).then((res)=>{
                        console.log(res)
                        if(res.code==0){
                               success(res.data)
                        }
                    
                    })
                }
            }
        }
    },
    mounted(){
        this.getList()
         tinymce.init({});
    },
    methods:{
        //出现新增框
        operation:function(operationStatus,companyID){
            var vm=this;
            this.operationStatus=operationStatus
            this.ifAdd=true
            this.$nextTick(()=>{
                this.$refs['addParams'].resetFields();
            }) 
            if(operationStatus==1){
                vm.$common.deletesObj(vm.addParams,'id')
                vm.addParams.imgUrl=''
                vm.titleMsg='新增'
            }else{
                vm.titleMsg='编辑'
                vm.$http.get('/api/console/project/query',{
                    params:{
                            id:companyID
                        },
                })
                .then(function(response){
                     vm.addParams=response.data
                    // for(var i in resTemp){
                    //     if(i=='updateDate'||i=='createDate'){
                    //         delete resTemp[i]
                    //     }
                    // }
                    // vm.addParams=resTemp
                })
                
            
            }
        },
        //获取列表
        getList(type){
            var vm=this;
            vm.getListParams.pageNo=type?type:1
            vm.$http.get('/api/console/project/queryPage',
                {params:vm.getListParams}
            )
            .then(function(response){
                vm.tableData=response.data&&response.data.items?response.data.items:[]
                vm.totals=parseInt(response.data.page.rowCount)*1
            })
        },
        uploadImg(val){
            this.$set(this.addParams,"imgUrl",val)
        },
        //新增编辑数据
        save:function(formName){
            
            var vm=this;
            vm.$refs[formName].validate((valid) => {
                if (valid) {
                    vm.$http.post('/api/console/project/save',vm.addParams)
                    .then(function(response){
                        if(response.code==0){
                            vm.$common.Alerts.call(vm,"保存成功",2)
                            vm.ifAdd=false;
                            vm.getList(vm.getListParams.pageNo)
                        }
                    })
                }
            })

            
        },
        //是否删除数据
        ifDelete:function(companyID){
            var vm=this;
            // this.ifDeleteBox=true
            this.$common.Delets.call(this,(action, instance, done)=>{
                if (action === 'confirm') {
                    vm.$http.post('/api/console/project/delete',{id:companyID})
                    .then(function(response){
                        if(response.code==0){
                            done()
                            vm.$common.Alerts.call(vm,"删除成功",2)
                            // vm.ifDeleteBox=false
                            vm.getList()
                        }
                            
                    })
                }else{
                    done()
                }
            })
        },

    },
    components:{
        PhotoUpload,
        Editor 
    }
}
</script>

<style lang="less">
.case{
    .LOGO{
        width: 100px;
        text-align: right;
        line-height: 60px;
        margin-right: 20px;
    }
    .el-select{
        width: 100%;
    }
}
</style>




// WEBPACK FOOTER //
// src/views/case/case.vue